export function EventCardSkeleton() {
  return (
    <article
      aria-hidden
      className="relative flex min-h-[22rem] w-full animate-pulse flex-col overflow-hidden rounded-3xl bg-surface shadow-card"
    >
      <div className="absolute inset-0 bg-border/30" />
      <div className="absolute left-4 top-4 h-6 w-20 rounded-full bg-border/50" />
      <div className="absolute inset-x-0 bottom-0 p-5">
        <div className="h-3 w-24 rounded-full bg-border/50" />
        <div className="mt-3 h-7 w-4/5 max-w-xs rounded-full bg-border/50" />
        <div className="mt-3 h-4 w-28 rounded-full bg-border/40" />
        <div className="mt-6 h-10 w-full rounded-2xl bg-border/50" />
      </div>
    </article>
  );
}
